module.exports = __webpack_public_path__ + "static/media/bank_wire_transfer_logo.64ee85c8.svg";